import React from 'react'

const Holdings = () => {
  return (
    <div>Holdings</div>
  )
}

export default Holdings